<script>

const axios = require('axios').default;

export default {

  name: 'SetObjective',

  mixins: [axios],

  props: {
    objective: {
      // True if user is look for aging resources.
      // False if user is look for disability resources.
      required: false,
      type: Boolean,
    },
  },

  watch: {
    'selectedObjective': {
      handler: function (value) {
        if (value !== null) {
          this.setObjective(value)
        }
      },
      deep: true
    }
  },

  data() {
    return {
      selectedObjective: false
    };
  },

  computed: {},

  created() {
    this.selectedObjective = this.objective;
  },

  methods: {
    setObjective(value) {
      this.selectedObjective = value
      return axios.post('/objective', {is_aging: value}).catch((errors) => {
        console.error('Objective did not get saved to session.')
      });
    },
    getStyleClass(value) {
      if (value) {
        return 'bg-gold-default hover:bg-gold-darker text-white'
      } else {
        return 'bg-white border-3 border-gray-100 hover:bg-gray-100 text-cerulean-default'
      }
    },
    goToProviders(value){
      if(value !== null){
        this.setObjective(value).then(() => window.location.href = '/providers');
      }
    }
  },
};

</script>

<template>
  <div class="flex flex-col lg:flex-rowx">
    <div class="w-full  m-2 mb-4 lg:px-12">
      <button type="button" @click="goToProviders(true)"
              :class="`w-full text-sm sm:text-2xl md:text-3xl lg:text-lg xl:text-3xl shadow-lg font-semibold py-12 px-12 xl:px-16 rounded-full ` + getStyleClass(selectedObjective === true)">
        Search for Iowa's  <span :class="selectedObjective === true ? 'text-cerulean-default' : 'text-gold-default'">Aging</span>
        and Disability Services
      </button>
    </div>
    <div class="w-full m-2  lg:px-24">
      <a href="https://iowacompass.org" target="_blank" class="block text-center text-cerulean-default w-full text-sm sm:text-lg md:text-xl lg:text-lg xl:text-xl shadow-lg font-semibold py-6 px-8 xl:px-16 rounded-full">Search Additional <span class="text-gold-default">Disability</span> Resources</a>
<!--      <button type="button" @click="goToProviders(false)"-->
<!--              :class="`w-full text-sm sm:text-2xl md:text-3xl lg:text-lg xl:text-3xl shadow-lg font-semibold py-8 px-8 xl:px-16 rounded-full ` + getStyleClass(selectedObjective === false)">-->
<!--          View <span :class="selectedObjective === false ? 'text-cerulean-default' : 'text-gold-default'">Disability</span>-->
<!--          Related Resources-->
<!--        </button>-->
    </div>
  </div>
</template>